export const svgTruck = (): google.maps.Symbol => {
  const g = window.google?.maps;
  return {
    path: "M8 0C3.582 0 0 3.582 0 8s8 16 8 16 8-12.418 8-16-3.582-8-8-8zm0 11a3 3 0 1 1 0-6 3 3 0 0 1 0 6z",
    fillOpacity: 1,
    fillColor: "#D6001C",
    strokeWeight: 2,
    strokeColor: "#D6001C",
    scale: 2,
    rotation: 0,
    labelOrigin: g ? new g.Point(8, 36) : undefined,
    anchor: g ? new g.Point(8, 30) : undefined,
  };
};

// Workshop icons now match the truck icon's path and style for consistency
const WORKSHOP_PATH =
  "M8 0C3.582 0 0 3.582 0 8s8 16 8 16 8-12.418 8-16-3.582-8-8-8zm0 11a3 3 0 1 1 0-6 3 3 0 0 1 0 6z";

const makeWorkshopIcon = (fillHex: string): google.maps.Symbol => {
  const g = window.google?.maps;
  return {
    path: WORKSHOP_PATH,
    fillOpacity: 1,
    fillColor: fillHex,
    strokeWeight: 2,
    strokeColor: fillHex,
    scale: 2,
    rotation: 0,
    labelOrigin: g ? new g.Point(8, 36) : undefined,
    anchor: g ? new g.Point(8, 30) : undefined,
  };
};

export const dealerWorkshopIcon = (): google.maps.Symbol =>
  makeWorkshopIcon("#041E42");

export const customerWorkshopIcon = (): google.maps.Symbol =>
  makeWorkshopIcon("#ff6200ff");

export const externalCompanyIcon = (): google.maps.Symbol =>
  makeWorkshopIcon("#00811aff");
